import api from '../Utils/api'

export const getDashboardFunction = async () => {
  const apiResponse = await api('GET', 'dashboard/user', null)
  return apiResponse
}

export const updateUserRole = async (role) => {
  const apiResponse = await api('POST', 'dashboard/user', { role: role }, true)
  return apiResponse
}
export const updateUserWorkType = async (work_type) => {
  const apiResponse = await api(
    'POST',
    'dashboard/user/work_type',
    { work_type: work_type },
    true
  )
  return apiResponse
}
